import React from 'react';
import { MTableToolbar } from 'material-table';
import './ToolbarWrapper.less';
import ToolbarYears from './ToolbarFilterYears';
import ToolbarFundings from './ToolbarFilterFundings';

export default function ToolbarWrapper(props) {
  const { filters } = props;

  return (
    <div>
      <div className="table-toolbar-container">
        <div style={{ width: '100%' }}>
          <MTableToolbar {...props.nativeProps} />
        </div>
        {props.customToolbarElement}
      </div>
      {filters && (
        <div className="filters-container">
          {filters.yearsProps && (
            <ToolbarYears
              years={filters.yearsProps.years}
              selectedYears={filters.yearsProps.selectedYears}
              onChange={filters.yearsProps.onChange}
            />
          )}
          {filters.fundingProps && (
            <ToolbarFundings
              selectedFundings={filters.fundingProps.selectedFundings}
              onChange={filters.fundingProps.onChange}
            />
          )}
          { props.customFilter }
        </div>
      )}
    </div>
  );
}
